



























import {Component, Vue} from "vue-property-decorator";
import bus from "@/main";
import UserItemEdit from "@/components/Admin/Users/UserItemEdit.vue";
import TherapistItemEdit from "@/components/Admin/Therapists/Edit/TherapistItemEdit.vue";
import ClientItemEdit from "@/components/Admin/Clients/Edit/ClientItemEdit.vue";
import MedicineItemEdit from "@/components/Admin/Settings/Medicines/Edit/MedicineItemEdit.vue";
import {BloodPressure, Measurement, Prescription} from "@/core/services/MedicaPro/models";
import MeasurementItemEdit
    from "@/components/Admin/Clients/Details/Components/MeasurementList/Components/Edit/MeasurementItemEdit.vue";
import MeasurementListEditCommentDialog
    from "@/components/Admin/Clients/Details/Components/MeasurementList/Components/MeasurementList-EditCommentDialog.vue";
import PrescriptionItemEdit
    from "@/components/Admin/Clients/Details/Components/PrescriptionList/Components/Edit/PrescriptionItemEdit.vue";
import BloodPressureItemEdit
    from "@/components/Admin/Clients/Details/Components/BloodPressureList/Components/Edit/BloodPressureItemEdit.vue";

@Component({
    components: {
        BloodPressureItemEdit,
        PrescriptionItemEdit,
        MeasurementListEditCommentDialog,
        MeasurementItemEdit,
        MedicineItemEdit,
        ClientItemEdit,
        TherapistItemEdit,
        UserItemEdit,
    }
})
export default class Modals extends Vue {
    userId = -1;
    therapistId = -1;
    clientId = -1;
    medicineId = -1;
    measurementItem: Measurement | null = null;
    measurementCommentEditItem: Measurement | null = null;
    prescriptionItem: Prescription | null = null;
    bloodPressureItem: BloodPressure | null = null;

    public created() {
        bus.$on('userEdit', (value: any) => {
            this.userId = -1;
            setTimeout(() => this.userId = value as number);
        });

        bus.$on('therapistEdit', (value: any) => {
            this.therapistId = -1;
            setTimeout(() => this.therapistId = value as number);
        });

        bus.$on('clientEdit', (value: any) => {
            this.clientId = -1;
            setTimeout(() => this.clientId = value as number);
        });

        bus.$on('medicineEdit', (value: any) => {
            this.medicineId = -1;
            setTimeout(() => this.medicineId = value as number);
        });

        bus.$on('measurementEdit', (value: Measurement) => {
            this.measurementItem = null;
            setTimeout(() => this.measurementItem = value);
        });
        bus.$on('measurementCommentEdit', (value: Measurement) => {
            this.measurementCommentEditItem = null;
            setTimeout(() => this.measurementCommentEditItem = value);
        });

        bus.$on('prescriptionEdit', (value: Prescription) => {
            this.prescriptionItem = null;
            setTimeout(() => this.prescriptionItem = value);
        });

        bus.$on('bloodPressureEdit', (value: BloodPressure) => {
            this.bloodPressureItem = null;
            setTimeout(() => this.bloodPressureItem = value);
        });
    }
}
